
            const data = {"name":"icon-play","data":{"width":"15","height":"15","viewBox":"0 0 15 15","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M12.405 7.119a.453.453 0 010 .79l-9.843 6.915c-.309.217-.562.075-.562-.317V.521c0-.391.253-.534.562-.317l9.843 6.915z\"/>"}}
        
                module.exports = data
                